import { Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow, Typography, } from "@mui/material";
import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import Home from "../../home/Home";
import Snackbar from '../../Snacbar'
import { getUserId } from '../../Utils/Common';
import { useEffect } from "react";
import BillingReportsService from "../../../Services/Reports/BillingReportsService";
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  backgroundColor: "white",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  backgroundColor: "white",
  height: "100",
}));

function SupplimentaryBillReport() {
  const mystyle = {
    border: " 1px solid black",
    width: "10rem",
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5",
  };

  ////setdetails
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [loading, setloading] = useState(false)
  const [radiovalue, setradiovalue] = useState("1");
  const [inputhidden, setinputhidden] = useState(false);

  const [showPocs, setshowPocs] = useState(false)
  const [refreshPocs, setrefreshPocs] = useState(false)
  const [dwnldBillPocs, setdwnldBillPocs] = useState(false)

  const [FilteredDetails, setFilteredDetails] = useState([])

  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [Sup_Values, setSup_Values] = useState({
    jobil: '',
    sub: '',
    printto: '',
    ///summary
    totaljobNo: '0',
    taxablevalue: '0.00',
    cgstAmat: '0.00',
    sgstAmt: '0.00',
    igstAmt: '0.00',
    totallBillingAMt: '0.00',
  });
  const jobilhandlechange = (e) => {
    setSup_Values({ ...Sup_Values, jobil: e.target.value })
  };
  const subhandlechange = (e) => {
    setSup_Values({ ...Sup_Values, sub: e.target.value })
  };
  const printtohandlechange = (e) => {
    setSup_Values({ ...Sup_Values, printto: e.target.value })
  };
  const radiovalueOnchange = (e) => {
    setradiovalue(e.target.value)
    setSup_Values({ ...Sup_Values, jobil: '', sub: '', printto: '' })
    if (e.target.value === '1') {
      setinputhidden(false)
    } else {
      setinputhidden(true)
    }
  }
  ///keydown 
  const jobNokeydown = (e) => {
    if (e.key === 'Enter') {
      document.getElementById('billprintoId').focus()
    }
  }
  const billprintokeydown = (e) => {
    if (e.key === 'Enter') {
      if (radiovalue === '1') {
        document.getElementById('subId').focus()
      }
    }
  }
  ////
  const handleClose = () => {
    setOpen(false)
  }
  ///clear summary
  const ClearSummary = () => {
    setSup_Values({ ...Sup_Values, totaljobNo: '0', taxablevalue: '0.00', cgstAmat: '0.00', sgstAmt: '0.00', igstAmt: '0.00', totallBillingAMt: '0.00', })
  }
  ///getfunctions=============>
  const getBillPrintTo = () => {
    BillingReportsService.getBillPrintTo().then(res => {
      setdetails2(res.data)
    })
  }
  ////
  const searchBtn = () => {
    if (Sup_Values.jobil !== '') {
      let details = { jobNo: Sup_Values.jobil }
      BillingReportsService.getSupplementaryBillBasedOnJobNo(details).then(res => {
        setdetails1(res.data);
      })
    } else {
      setMessage('Kindly Enter the job no')
      setseverit('warning')
      setOpen(true)
      document.getElementById('jobilId').focus();
    }
  }
  const labelchange = () => {
    if (radiovalue === "1") {
      return "JobNo";
    } else if (radiovalue === "2") {
      return "Sup_BillNo";
    } else if (radiovalue === "3") {
      return "BillNo";
    }
  };
  const showBtnClick = () => {
    setshowPocs(true)
    setloading(true)
    ClearSummary();
    var Billno, flag, Inv_No = '';
    if (radiovalue === '1') {
      if (Sup_Values.jobil !== '') {
        if (Sup_Values.sub !== '') {
          Billno = Sup_Values.sub
          flag = 1
          Inv_No = '-1'
        } else {
          setMessage('Kindly select the supplementary bill no ..!!')
          setseverit('warning')
          setOpen(true)
          document.getElementById('subId').focus();
          setshowPocs(false)
          setloading(false)
        }
      } else {
        setMessage('Please Enter the Job No', 'Warning ..!!')
        setseverit('warning')
        setOpen(true)
        document.getElementById('jobilId').focus();
        setshowPocs(false)
        setloading(false)
      }
    } else if (radiovalue === '2') {
      if (Sup_Values.jobil !== '') {
        Billno = '-1'
        flag = 2
        Inv_No = Sup_Values.jobil;
      } else {
        setMessage('Please Enter the Bill No', 'Warning ..!!')
        setseverit('warning')
        setOpen(true)
        document.getElementById('jobilId').focus();
        setshowPocs(false)
        setloading(false)
      }
    } else if (radiovalue === '3') {
      if (Sup_Values.jobil !== '') {
        Billno = Sup_Values.jobil;
        flag = 1
        Inv_No = '-1';
      } else {
        setMessage('Please Enter the supplementary Bill No', 'Warning ..!!')
        setseverit('warning')
        setOpen(true)
        document.getElementById('jobilId').focus();
        setshowPocs(false)
        setloading(false)
      }
      let details = { billNo: Billno, createdBy: getUserId, flagbill: flag, invoiceNo: Inv_No, }
      BillingReportsService.showSupplementaryBill(details).then(res => {
        const data = res.data;
        const details = data.map((item) => item)
        if (details[0] === [] || !details[0]) {
          setMessage('No Data Found!!')
          setseverit('warning')
          setOpen(true)
          setshowPocs(false)
          setloading(false)
        } else {
          var totaljob = 0, valueTaxableAmount = 0, valueCGSTamount = 0, valueSGSTamount = 0, valueIGSTamount = 0, valueTotalBillAmount = 0
          var jobCount = 0;
          var valueJob = "";
          for (let i = 0; i < details.length; i++) {
            if (details[i].consignmentId !== valueJob) {
              jobCount += 1;
              valueJob = details[i].consignmentId;
            }
            totaljob = jobCount;
            valueTaxableAmount += details[i].billAmount;
            valueCGSTamount += details[i].cgstAmt;
            valueSGSTamount += details[i].sgstAmt;
            valueIGSTamount += details[i].igstAmt;
            valueTotalBillAmount += details[i].totalBillAmount;
          }
          setSup_Values({
            ...Sup_Values, totaljobNo: totaljob, taxablevalue: valueTaxableAmount.toFixed(2), cgstAmat: valueCGSTamount.toFixed(2), sgstAmt: valueSGSTamount.toFixed(2),
            igstAmt: valueIGSTamount.toFixed(2), totallBillingAMt: valueTotalBillAmount.toFixed(2)
          })
          setdetails3(res.data);
          setFilteredDetails(res.data);
          setshowPocs(false)
          setloading(false)
        }
      })
    }
    setshowPocs(false)
  }
  const RefreshBtnClick = () => {
    setrefreshPocs(true)
    setSup_Values({ ...Sup_Values, jobil: ' ', sub: ' ', printto: ' ' })
    setdetails1([]);
    setdetails3([]);
    setradiovalue('1')
    setinputhidden(false)
    ClearSummary();
    setshowPocs(false)
    setrefreshPocs(false)
  }
  const DownloadBtnClick = () => {
    setdwnldBillPocs(true)
    var billno, flagBill, invoiceno, billby = '';
    if (radiovalue === '1') {
      billno = Sup_Values.jobil
      flagBill = 1
      invoiceno = '-1'
    } else if (radiovalue === '2') {
      billno = '-1'
      flagBill = 2
      invoiceno = Sup_Values.jobil
    } else if (radiovalue === '3') {
      billno = Sup_Values.jobil
      flagBill = 1
      invoiceno = '-1'
    }
    if (Sup_Values.printto === 'IMPORTER' || Sup_Values.printto === 'EXPORTER') {
      billby = '1'
    } else {
      billby = '2'
    }
    let details = {
      fileName: Sup_Values.jobil, billNo: billno, flagbill: flagBill,
      invoiceNo: invoiceno, billBy: billby, createdBy: getUserId()
    }
    BillingReportsService.SupplementaryInvoiceBillPdfPrint(details).then((res) => {
      const filename = res.data.message;
      // window.open('http://localhost:8080/ExportFiles/' + filename.toString(), "_blank")
      window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");

    })
    setdwnldBillPocs(false)
  }

  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getBillPrintTo();
  }, []);

  //serach table
  const jobnoSrch = () => {
    return <input style={{ width: '60px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { jobnoSearchOnchange(e.target.value) }} />
  }
  const gstBillNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { billnoSearchOnchange(e.target.value) }} />
  }
  const importerSrch = () => {
    return <input style={{ width: '90px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { impNameSearchOnchange(e.target.value) }} />
  }
  const modeSrch = () => {
    return <input style={{ width: '60px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { modeSearchOnchange(e.target.value) }} />
  }
  const containerSrch = () => {
    return <input style={{ width: '100px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { containerNoOnchange(e.target.value) }} />
  }
  const jobnoSearchOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.consignmentId.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const billnoSearchOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.invoiceNo.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const impNameSearchOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.iecName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const modeSearchOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.transitMode.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const containerNoOnchange = (searchedVal) => {
    const filteredvalue = details3.filter((trns) => {
      return trns.containerNo.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue < 1) {
      setFilteredDetails(details3)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }

  return (
    <div>
      <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
      <Home />
      <div style={{ paddingLeft: '80px' }}>
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
          :
          <ItemPap>
            <Grid container>
              <Grid item xs={8}>
                <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '23px', marginTop: '1%', marginBottom: '1%', }}><center>SUPPLIMENTRY BILL DOWNLOAD</center></div>
                <Row>
                  <Col>
                    <Form.Check style={mystyle1} checked={radiovalue === '1'} onChange={radiovalueOnchange} inline label='Job No' value={'1'} type='radio' />
                    <Form.Check style={mystyle1} checked={radiovalue === '2'} onChange={radiovalueOnchange} inline label='Sub BillNo' value={'2'} type='radio' />
                    <Form.Check style={mystyle1} checked={radiovalue === '3'} onChange={radiovalueOnchange} inline label='BillNo' value={'3'} type='radio' />
                  </Col>
                </Row>
                <br></br>
                <Row>
                  <Col xs={2}>
                    <label style={mystyle1}>{labelchange()}</label>
                  </Col>
                  <Col xs={2}>
                    <Form.Control size="sm" type="text" id='jobilId' style={mystyle} value={Sup_Values.jobil}
                      onChange={jobilhandlechange} onKeyDown={jobNokeydown}></Form.Control>
                  </Col>
                  <Col>
                    <div hidden={inputhidden}>
                      <Row>
                        <Col xs={6}>
                          <Button variant="success" size="sm" onClick={searchBtn}>Search</Button>{" "}
                          <label style={mystyle1}>Sub_BillNo</label>
                        </Col>
                        <Col xs={2}>
                          <Form.Select id='subId' size="sm" style={mystyle} value={Sup_Values.sub} onChange={subhandlechange} >
                            <option value='-1'> ---SELECT--- </option>
                            {details1.map(trns => (
                              <option value={trns.billNo}>{trns.billNo}</option>
                            ))}
                          </Form.Select>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={2}>
                    <label style={mystyle1}>Bill PrintTo</label>
                  </Col>
                  <Col xs={4}>
                    <Form.Select size="sm" style={mystyle} value={Sup_Values.printto} onKeyDown={billprintokeydown} onChange={printtohandlechange} id='billprintoId'>
                      <option value='-1'> ---SELECT--- </option>
                      {details2.map(trns => (
                        <option value={trns.billPaidTo}>{trns.billPaidTo}</option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
                <Row >
                  <Col lg={2}></Col>
                  <Col lg={6} className="mt-4">
                    <Button style={{ fontFamily: 'Times New Roman'}}variant="primary" size="sm" onClick={showBtnClick}>{showPocs ? 'processing...' : 'Show'}</Button>{" "}
                    <Button style={{ fontFamily: 'Times New Roman'}}variant="secondary" size="sm" onClick={RefreshBtnClick}>{refreshPocs ? 'processing...' : 'Refresh'}  </Button>{" "}
                    <Button style={{ fontFamily: 'Times New Roman'}}variant="success" size="sm" onClick={DownloadBtnClick}>{dwnldBillPocs ? 'processing...' : 'Download Bill Copy'}</Button>
                  </Col>
                  <Col lg={3}></Col>
                </Row>
              </Grid>
              <Grid item xs={4}>
                <ItemPap1>
                  <Typography color={"darkblue"} fontWeight={"bolder"} variant={"h6"}> Summary </Typography>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TotalJobNo</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{ justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{Sup_Values.totaljobNo}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TaxableValue</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{Sup_Values.taxablevalue}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>CGSTAmount</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{Sup_Values.cgstAmat}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>SGSTAmount</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{Sup_Values.sgstAmt}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>IGSTAmount</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{Sup_Values.igstAmt}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TotalBilling Amount</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{Sup_Values.totallBillingAMt}</Form.Label></Col>
                  </Row>
                </ItemPap1>
              </Grid>
            </Grid>
            <ItemPap1>
              <TableContainer sx={{ height: 360 }} className="mt-1">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>JobNo {jobnoSrch()}</StyledTableCell>
                      <StyledTableCell>GST_BillNo {gstBillNoSrch()}</StyledTableCell>
                      <StyledTableCell>ImporterName {importerSrch()}</StyledTableCell>
                      <StyledTableCell>ForwarderName</StyledTableCell>
                      <StyledTableCell>Mode {modeSrch()}</StyledTableCell>
                      <StyledTableCell>TotalPkg</StyledTableCell>
                      <StyledTableCell>Gross_Wt</StyledTableCell>
                      <StyledTableCell>Bill_Paid_By</StyledTableCell>
                      <StyledTableCell>Bill_Paid_Date</StyledTableCell>
                      <StyledTableCell>TaxableValue</StyledTableCell>
                      <StyledTableCell>CGST_Amount</StyledTableCell>
                      <StyledTableCell>SGST_Amount</StyledTableCell>
                      <StyledTableCell>IGST_Amount</StyledTableCell>
                      <StyledTableCell>Total_BillAmount</StyledTableCell>
                      <StyledTableCell>MAWB/MBL</StyledTableCell>
                      <StyledTableCell>HAWB/HBL</StyledTableCell>
                      <StyledTableCell>ContainerNo {containerSrch()}</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((trns, index) => (
                        <TableRow hover key={trns.serialNumber}>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentId}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.iecName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.fwdName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.transitMode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.noOfPkg}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.grNetWeight}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billPaidBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billPaidDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.cgstAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sgstAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igstAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalBillAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.mawbNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawbNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.containerNo}</StyledTableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>}
      </div>
    </div>
  );
}

export default SupplimentaryBillReport;
